// extracted by mini-css-extract-plugin
export default {"wrapper":"providerInfo_wrapper__ud5gc","starRating":"providerInfo_starRating__jpHNS","title":"providerInfo_title__l+Dht","address":"providerInfo_address__ir-nR"};